import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { DataPointReport } from "../../types/reportTypes.ts"

export const updateReport = async (id: number, report: DataPointReport) => {
  await authFetch(`${API_BASE}/reports/${id}`, {
    method: "PUT",
    body: JSON.stringify(report),
    headers: {
      "Content-Type": "application/json",
    },
  })
}
